import { Expose, Type } from "class-transformer";
import { BaseModel } from "src/shared/models";

export class VehicularAssistance extends BaseModel {
    @Expose()
    code = "";
    @Expose()
    name = "";
    @Expose({ name: "subServices" })
    @Type(() => VehicularAssistance)
    services: Array<VehicularAssistance> = [];
}
